"use strict";

exports.DexScreenerHttpRepository = void 0;
var _constants = require("../data/constants");
var _DexScreenerError = require("../data/errors/DexScreenerError");
var _sdkTypes = require("../data/sdk-types");
var _HttpRepository = require("./HttpRepository");
class DexScreenerHttpRepository extends _HttpRepository.HttpRepository {
  constructor() {
    super(_constants.DEXSCREENER_API_BASE_URL);
  }
  static findUsdTokenPair(pairs, symbol) {
    const orderedPairs = pairs.sort((a, b) => {
      // First, sort by the baseToken.symbol
      if (a.baseToken.symbol.toLowerCase() === (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase()) && b.baseToken.symbol.toLowerCase() !== (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase())) return -1;
      if (a.baseToken.symbol.toLowerCase() !== (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase()) && b.baseToken.symbol.toLowerCase() === (symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase())) return 1;

      // Then, sort by volume.h24 if baseToken.symbols are equal
      if (a.volume.h24 > b.volume.h24) return -1;
      if (a.volume.h24 < b.volume.h24) return 1;
      return 0;
    });
    const pair = orderedPairs.find(p => {
      if (symbol && symbol.includes('USD')) {
        return p.baseToken.symbol.includes('USD') && p.priceUsd;
      }
      return p.quoteToken.symbol.includes('USD') && (!symbol || p.baseToken.symbol.includes(symbol)) && p.priceUsd;
    });
    if (!pair) {
      throw new _DexScreenerError.DexScreenerError('No pairs found', {
        component: _sdkTypes.ErrorContextComponent.DEXSCREENER_FIND_USD_TOKEN_PAIR,
        description: 'Dexscreener could not find any pairs with USD as quote token'
      });
    }
    return pair;
  }
  async getPriceForTokenAddressAsync(tokenAddress, symbol) {
    const res = await this.getAsync("dex/tokens/".concat(tokenAddress));
    if (!res.pairs || res.pairs.length === 0) {
      throw new _DexScreenerError.DexScreenerError('No pairs found', {
        component: _sdkTypes.ErrorContextComponent.DEXSCREENER_GET_PRICE_FOR_TOKEN_ADDRESS,
        description: 'Dexscreener could not find any pairs for the token address'
      });
    }
    const usdPair = DexScreenerHttpRepository.findUsdTokenPair(res.pairs, symbol);
    return parseFloat(usdPair.priceUsd);
  }
  async getPriceForPairAsync(pair) {
    const res = await this.getAsync("dex/search?q=".concat(pair));
    if (!res.pairs || res.pairs.length === 0) throw new _DexScreenerError.DexScreenerError('No pairs found', {
      component: _sdkTypes.ErrorContextComponent.DEXSCREENER_GET_PRICE_FOR_PAIR,
      description: 'Dexscreener could not find any pairs for the pair query'
    });
    const baseSymbol = pair.split(' ')[0];
    const usdPair = DexScreenerHttpRepository.findUsdTokenPair(res.pairs, baseSymbol);
    return parseFloat(usdPair.priceUsd);
  }
}
exports.DexScreenerHttpRepository = DexScreenerHttpRepository;